module.exports = __webpack_public_path__ + "admin-thumbs/s-facts-figures.png";